const withPattern = (pattern, build) => Object.assign(build, { pattern })

const routes = {
  home: "/",
  cleans: "/cleans",
  residencies: "/residencies",
  cleaners: "/cleaners",
  newCleaner: "/cleaners/new",
  notifications: "/notifications",
  settings: "/settings",
  newBooking: "/bookings/new",
  bookingDetail: withPattern("/bookings/:id", (id) => `/bookings/${id}`),
  editBooking: withPattern("/bookings/:id/edit", (id) => `/bookings/${id}/edit`),
  sendMessage: withPattern("/bookings/:id/send", (id) => `/bookings/${id}/send`),
  signIn: "/session/new",
  forgotPassword: "/passwords/new",
  resetPassword: withPattern("/passwords/:token/edit", (token) => `/passwords/${token}/edit`),
  cleanerPortal: withPattern("/c/:token", (token) => `/c/${token}`),
}

export default routes
